module.exports = __webpack_public_path__ + "static/media/Group.17d72235.jpg";